import { fillString } from '@local_modules/generic/string-template.js'
import htmlTemplateNotAuthorised from './not-authorised.html'
import { setElementHtml } from '../../generic-js/dom.js'

export function showUnauthorisedAccount (params) {
  const message = params?.isLoggedIn ? 'sign in another account' : 'sign in your account'

  const html = fillString(htmlTemplateNotAuthorised, { message })

  setElementHtml('app-content', html)
}
